import {
  Component,
  EventEmitter,
  Input,
  Output,
  ElementRef,
  HostListener,
  forwardRef
} from '@angular/core';
import { Router } from '@angular/router';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
@Component({
  selector: 'lms-select-dropdown',
  templateUrl: './select-dropdown.component.html',
  styleUrls: ['./select-dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectDropdownComponent),
      multi: true
    }
  ]
})
export class SelectDropdownComponent implements ControlValueAccessor {
  @Output() change = new EventEmitter<Object>();
  @Input() items: Array<any>;
  @Input() disabled: boolean = false;
  @Input() selectedItem: any = null;
  @Input() size: any = null;
  @Input() label: any = 'actions.selected';
  public openSelect: boolean = false;

  public propagateChange = (_: any) => {};
  public propagateTouched = (_: any) => {};

  constructor(public router: Router, public elementRef: ElementRef) {}
  writeValue(value: any): void {
    this.selectedItem = value;
  }
  registerOnChange(fn): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn): void {
    this.propagateTouched = fn;
  }

  toogleSelect(): void {
    if (!this.disabled) {
      this.openSelect = !this.openSelect;
    }
  }

  selectItem(item: any): void {
    if (!item.disabled) {
      this.selectedItem = item.key;
      this.propagateChange(item.key);
    }
  }

  get selected(): void {
    return this.selectedItem
      ? this.items.find((item) => item.key === this.selectedItem).value
      : this.label;
  }
  @HostListener('document:click', ['$event'])
  hide(event: any): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.openSelect = false;
    }
  }
}
